import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwipeLeftAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swipe_left_alt"}/>
}
